import { PagePaths } from '#app/shared/navigation/pagePaths'
import { ExclamationCircleIcon } from '@heroicons/react/24/outline'
import { Box, Button, Container, Typography } from '@mui/material'
import type React from 'react'

export const GoToProfileActionButton: React.FC = () => {
  return (
    <Button
      variant="contained"
      color="primary"
      href={PagePaths.Account.Profile}
      sx={{
        textTransform: 'capitalize',
        fontWeight: 700,
        borderRadius: 2
      }}
    >
      Go To Profile
    </Button>
  )
}

export const GoHomeActionButton: React.FC = () => {
  return (
    <Button
      variant="contained"
      color="primary"
      href={PagePaths.Home}
      sx={{
        textTransform: 'capitalize',
        fontWeight: 700,
        borderRadius: 2
      }}
    >
      Go Back Home
    </Button>
  )
}

type StatusPageProps = {
  /** Testing identifier. */
  'data-testid'?: string
  title: string
  subtitle?: string
  action?: React.ReactNode
}

export const StatusPage: React.FC<StatusPageProps> = ({
  'data-testid': dataTestId,
  title,
  subtitle,
  action
}) => {
  return (
    <Box
      data-testid={dataTestId}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        textAlign: 'center',
        backgroundColor: '#f5f5f5'
      }}
    >
      <Container>
        <Typography
          variant="h4"
          pb={4}
          color="#7e7e7e"
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            gap: 2
          }}
        >
          <Typography sx={{ fontSize: 40, color: '#ff0000' }}>
            <ExclamationCircleIcon />
          </Typography>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body1" color="#a1a1a1">
            {subtitle}
          </Typography>
        )}
        {action && <Box mt={6}>{action}</Box>}
      </Container>
    </Box>
  )
}
